import moment from 'moment';
import React, { Component } from 'react';
import {
  // ButtonDropdown,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import language from '../../assets/languages/language';
import { _getProfile, renderHTMLContent } from '../../common/function';
import Loader from '../../common/loader';
import { showFailure, showSuccess } from '../../common/toast';
import FD from '../RestAPI/fetchData';
import App_data from '../config/App_data';
import { SHOW_CFA_UNLIMITED_PLUS } from '../../common/constant';
import {
  SUBSCRIPTION_BADGE,
  getSubscriptionDateLabel,
} from '../../common/subscriptionBadge';

/* eslint-disable*/
class SubscriptionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      ValidToken: false,
      examData: '',
      examPlan: '',
      examDetails: '',
      new_table_array: [],

      no_result_display: '',
      profileInfo: '',
      isLoading: true,
      isCancelSubscription: false,
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };
  componentDidMount() {
    window.scroll(0, 0);
    this.props.params ? this.setState({ username: this.props.params.username }) : null;
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    this.getPackages(data);
  }
  cancelSubscriptionToggle = async (packageId, subscriptionId, subscriptionScheduleId) => {
    if (packageId) {
      this.setState({
        isCancelSubscription: !this.state.isCancelSubscription,
        packageId,
        subscriptionId,
        subscriptionScheduleId,
      });
    } else {
      this.setState({ isCancelSubscription: !this.state.isCancelSubscription });
    }
  };
  onCancelSubscription = async () => {
    this.state.packageId, this.state.subscriptionId;
  };
  getPackages = async data => {
    console.log('this API will be call again', data);

    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, profileInfo: resp.profileInfo });
        if (resp.profileInfo.exam_selected !== '') {
          FD.callAPI(App_data.backend_api + '/user/getPackages', data).then(resp_package => {
            if (resp_package.success) {
              this.setState({
                examPlan: resp_package.exam_plans,
              });
            }
            var data_arr = JSON.parse(resp.profileInfo.exam_selected);
            var dataset = {
              ...data,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  this.setState({
                    examData: exam_data,
                    examDetails: resp_exam.examdetails,
                  });

                  // `examPlan` is filtered by users.exam_package, which the
                  // admin cancel mutates: dropping a plan there removes it from
                  // the catalogue list while `cancel_at_period_end` keeps the
                  // entitlement alive to the end of the paid period. Union in
                  // `entitlementPlans` (every plan the user actually holds) so
                  // a cancelled-but-still-active subscription keeps its row.
                  const planList = (resp_exam.examPlan || []).slice();
                  const seenPlanIds = {};
                  for (var pi = 0; pi < planList.length; pi++) {
                    seenPlanIds[String(planList[pi].id)] = true;
                  }
                  const extraPlans = resp_exam.entitlementPlans || [];
                  for (var ei = 0; ei < extraPlans.length; ei++) {
                    if (!seenPlanIds[String(extraPlans[ei].id)]) {
                      seenPlanIds[String(extraPlans[ei].id)] = true;
                      planList.push(extraPlans[ei]);
                    }
                  }

                  resp_exam.examData.map(examData => {
                    examData.levels.map(levelsItem => {
                      planList.map(examPlanItem => {
                        // Match on package_id when the level carries one.
                        // Matching on package_val alone paired a monthly entry
                        // with its 12-month twin (79/1 both 'simple', 80/2 both
                        // 'expensive'), so the yearly plan row rendered the
                        // monthly's expiry — and the findElementIndex guard
                        // below meant the correct entry could never fix it.
                        // package_val remains the fallback for legacy entries
                        // written before package_id was emitted.
                        const levelPackageId =
                          levelsItem.package_id === undefined || levelsItem.package_id === null
                            ? null
                            : Number(levelsItem.package_id);
                        const matchesPlan =
                          levelPackageId !== null
                            ? levelPackageId === Number(examPlanItem.id)
                            : levelsItem.package_val === examPlanItem.package_val;

                        if (matchesPlan && examPlanItem.exam_id === examData.exam_id) {
                          resp_exam.examdetails.map(examName => {
                            if (examData.exam_id === examName.id) {
                              const findElementIndex = this.state.new_table_array.findIndex(
                                element => element.packageId == examPlanItem.id,
                              );
                              if (findElementIndex === -1) {
                                this.setState(prevState => ({
                                  new_table_array: [
                                    ...prevState.new_table_array,
                                    {
                                      packageId: examPlanItem.id,
                                      payment_interval: examPlanItem.payment_interval,
                                      subscriptionId: levelsItem.subscriptionId,
                                      subscriptionScheduleId: levelsItem.subscriptionScheduleId,
                                      cancelledSubscription: levelsItem.cancelledSubscription,
                                      exam_name: examName.name,
                                      package_type: examPlanItem.package_type,
                                      expiryDate: levelsItem.expiryDate,
                                      status: levelsItem.isActive,
                                      subscriptionState: levelsItem.subscription_state,
                                    },
                                  ],
                                }));
                              } else {
                                const { new_table_array: newData } = this.state;
                                newData[findElementIndex] = {
                                  ...newData[findElementIndex],
                                  cancelledSubscription: levelsItem.cancelledSubscription,
                                };
                                console.log('newData', newData);
                                this.setState(prevState => ({
                                  new_table_array: newData,
                                }));
                              }
                            }
                          });
                        }
                      });
                    });
                  });
                  this.setState({
                    isLoading: false,
                  });
                }
              },
            );
          });
        } else {
          this.setState({
            no_result_display:
              '<td colspan="6" className="" align="center">No Subscription Found</td>',
            isLoading: false,
          });
        }
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };
  cancelSubscription = async () => {
    const {
      token,
      idname,
      packageId: package_id,
      subscriptionId,
      subscriptionScheduleId,
    } = this.state;
    let subscriptionObject = {
      subscriptionId,
    };

    console.log('subscriptionScheduleId', subscriptionScheduleId);
    if (subscriptionScheduleId && !subscriptionId) {
      subscriptionObject = {
        subscriptionScheduleId,
      };
    }

    FD.callAPI(`${App_data.backend_api}/checkout_v1/cancelSubscription`, {
      token,
      idname,
      ...subscriptionObject,
      package_id,
    }).then(resp => {
      if (resp.success) {
        const { token, idname } = this.state;
        const data = {
          token,
          idname,
        };
        this.setState(
          {
            isCancelSubscription: false,
            packageId: '',
            subscriptionId: '',
          },
          () => {
            showSuccess('Your subscription has been cancelled');
            this.getPackages({ token, idname });
          },
        );
      } else {
        this.setState(
          {
            isCancelSubscription: false,
            packageId: '',
            subscriptionId: '',
          },
          () => {
            showFailure('Something went wrong');
          },
        );
      }
    });
  };

  render() {
    let subscription_data = this.state.examData;
    let showPurchasedPkgDetails = [];
    let profileInfo = this.state.profileInfo;

    let unlimitedData = '';
    let tableObject = {
      exam_name: '',
      package_type: '',
      expiryDate: '',
      status: '',
    };
    // this.state.examData.map((examData) => {
    //   examData.level.map((levelsItem) => {
    //     this.state.examPlan.map((examPlanItem) => {
    //       if (
    //         levelsItem.package_val === examPlanItem.package_val &&
    //         examPlanItem.exam_id === examData.exam_id
    //       ) {
    //         this.state.examDetails.map((examName) => {
    //           if (examData.exam_id === examName.id) {
    //             // tableObject.expiryDate = levelsItem.expiryDate;
    //             // tableObject.status = levelsItem.isActive;
    //             // tableObject.package_type = examPlanItem.package_type;
    //             new_table_array.push({
    //               exam_name:examName.name ,
    //               package_type: examPlanItem.package_type,
    //               expiryDate: levelsItem.expiryDate,
    //               status: levelsItem.isActive,
    //             });
    //           }
    //         });
    //       }
    //     });
    //   });
    // });
    if (
      profileInfo.cfaUnlimitedActiveExam === 'cfa' &&
      profileInfo.cfaUnlimitedPackage === 'true'
    ) {
      // #216 — distinguish CFA Unlimited+ (pkg 78) from CFA Unlimited (pkg 15)
      // by inspecting exam_package. Both owners share the cfaUnlimitedPackage
      // fast-path flag, so it alone cannot identify the purchased tier.
      //
      // Feature flag: while `SHOW_CFA_UNLIMITED_PLUS` is false the Plus branding
      // is suppressed even for users who own pkg 78 — they see the plain
      // "CFA Unlimited" label instead. Entitlement is unaffected.
      let ownedPlanIds = [];
      try {
        ownedPlanIds = JSON.parse(profileInfo.exam_package || '[]') || [];
      } catch (e) {
        ownedPlanIds = [];
      }
      const ownsPlusPlanId = Array.isArray(ownedPlanIds)
        && ownedPlanIds.map(Number).indexOf(78) !== -1;
      const hasPlusPackage = SHOW_CFA_UNLIMITED_PLUS && ownsPlusPlanId;
      const unlimitedPackageName = hasPlusPackage
        ? 'CFA Unlimited+ Package (All 3 Levels)'
        : 'CFA Unlimited Package (All 3 Levels)';

      unlimitedData = (
        <tr key='45'>
          <td> 0</td>
          <td className='exam-name'> CFA Level I</td>
          <td>{unlimitedPackageName}</td>
          <td> Lifetime valid</td>
          <td>Active</td>
          <td className='text-center'> - </td>
        </tr>
      );
    }
    // var unique = array.filter((v, i, a) =>{ return a.indexOf(v) === i});
    // console.log('agni parikshaaa==2222======>', unique);

    // console.log(subscription_data,"<================subscription_data","\n",this.state.examPlan,"<===============this.state.examPlan")
    // if (subscription_data.length) {
    //   let count = 1;
    //   showPurchasedPkgDetails = subscription_data.map((item, index) => {
    //     return (
    //       <tbody key={index}>
    //         {item.levels.length
    //           ? this.state.examPlan.map((data, index) =>
    //                item.exam_id === data.exam_id
    //                 ? item.levels.map((levelItem, levelIndex) => {
    //                   console.log("item.exam_id === data.exam_id",levelItem.package_id === data.id)
    //                     return levelItem.package_id == data.id ? (
    //                       <tr key={levelIndex}>
    //                         <td>{count++}</td>
    //                         {item.exam_id === data.exam.id ? (
    //                           <td className='exam-name'>{data.exam.name}</td>
    //                         ) : null}
    //                         {item.exam_id === data.exam.id &&
    //                         levelItem.package_val === data.package_val ? (
    //                           <td>{data.package_type}</td>
    //                         ) : null}
    //                         <td>
    //                           {console.log(
    //                             'data',
    //                             data,
    //                             'levelItem',
    //                             levelItem
    //                           )}
    //                           {levelItem.expiryDate
    //                             ? moment(levelItem.expiryDate).format('ll')
    //                             : 'Lifetime valid'}
    //                         </td>
    //                         <td>
    //                           {levelItem.isActive ? (
    //                             'Active'
    //                           ) : (
    //                             <div className='text-danger'>
    //                               {language.LC().EXPIRED}
    //                             </div>
    //                           )}
    //                         </td>
    //                         <td className='text-center'>
    //                           {data &&
    //                           data.payment_interval &&
    //                           data.payment_interval.includes('month') ? (
    //                             <button
    //                               type='button'
    //                               className='btn custom-btn-danger pointer_class'
    //                               onClick={() =>
    //                                 this.cancelSubscription(
    //                                   levelItem.package_id,
    //                                   levelItem.subscriptionId
    //                                 )
    //                               }
    //                               disabled={levelItem.cancelledSubscription}
    //                             >
    //                               Cancel Subscription
    //                             </button>
    //                           ) : (
    //                             '-'
    //                           )}
    //                         </td>
    //                       </tr>
    //                     ) : null;
    //                   })
    //                 : null
    //             )
    //           : null}
    //       </tbody>
    //     );
    //   });
    // }

    let count = 1;
    // #216 — When the hardcoded "CFA Unlimited / Unlimited+" row renders above
    // (driven by cfaUnlimitedPackage='true'), skip pkg 15 and pkg 78 entries
    // in the per-package table to avoid the row duplicating.
    const CFA_ALL_LEVELS_PLAN_IDS = [15, 78];
    const displayRows = unlimitedData
      ? this.state.new_table_array.filter(
          (row) => CFA_ALL_LEVELS_PLAN_IDS.indexOf(Number(row.packageId)) === -1,
        )
      : this.state.new_table_array;

    if (displayRows.length) {
      showPurchasedPkgDetails = displayRows.map((tableValues, index) => {
        return (
          <tbody key={index}>
            <tr key={index}>
              <td>{count++}</td>
              <td className='exam-name'>{tableValues.exam_name}</td>
              <td>{tableValues.package_type}</td>
              <td>
                {tableValues.expiryDate
                  ? getSubscriptionDateLabel(
                      tableValues.subscriptionState
                        ? { status: tableValues.subscriptionState }
                        : null,
                    ) + moment(tableValues.expiryDate).format('ll')
                  : 'Lifetime valid'}
              </td>
              <td>
                {/* A cancelled subscription inside its paid period is still
                    active, and rendering it as plain "Active" hid the fact
                    that it stops renewing. Shared vocabulary, so this row and
                    the /subscribe badge cannot disagree. */}
                {tableValues.subscriptionState ? (
                  <div
                    className={
                      SUBSCRIPTION_BADGE[tableValues.subscriptionState] &&
                      SUBSCRIPTION_BADGE[tableValues.subscriptionState].tone === 'danger'
                        ? 'text-danger'
                        : ''
                    }
                  >
                    {SUBSCRIPTION_BADGE[tableValues.subscriptionState]
                      ? SUBSCRIPTION_BADGE[tableValues.subscriptionState].label
                      : ''}
                  </div>
                ) : tableValues.status ? (
                  'Active'
                ) : (
                  <div className='text-danger'>{language.LC().EXPIRED}</div>
                )}
              </td>
              {/* <td className='text-center'>
                {tableValues &&
                tableValues.payment_interval &&
                ['month', 'day', 'year'].includes(tableValues.payment_interval) ? (
                  <button
                    type='button'
                    className='btn custom-btn-danger pointer_class'
                    onClick={() =>
                      // this.cancelSubscription(tableValues.packageId, tableValues.subscriptionId)
                      this.cancelSubscriptionToggle(
                        tableValues.packageId,
                        tableValues.subscriptionId,
                        tableValues.subscriptionScheduleId,
                      )
                    }
                    disabled={tableValues.cancelledSubscription}
                  >
                    {tableValues.cancelledSubscription ? 'Cancelled' : 'Cancel Subscription'}
                  </button>
                ) : (
                  '-'
                )}
              </td> */}
            </tr>
          </tbody>
        );
      });
    }

    if (
      profileInfo.cfaUnlimitedActiveExam === '' &&
      profileInfo.subscription_details === '' &&
      profileInfo.exam_package === ''
    ) {
      showPurchasedPkgDetails = (
        <tr>
          <td colSpan='5'>
            <div className='text-center'>{language.LC().NO_SUBSCRIPTION_DETAIL}</div>
          </td>
        </tr>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='card height_70vh'>
          <div className='card-header subscription-header d-flex align-items-center justify-content-between'>
            <div className='mb-1 d-inline-block'>{language.LC().SUBSCRIPTION_DETAIL}</div>
            <div className='card-actions float-md-right'>
              <button
                type='button'
                className='btn btn-primary pointer_class mb-0'
                onClick={_getProfile.bind(this, this.state.username)}
              >
                {' '}
                {language.LC().GO_TO_PROFILE}{' '}
              </button>
            </div>
          </div>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <div id='table_responsive_wrapper'>
              <div className='table-responsive order_his_tb'>
                <table className='cart_table table'>
                  <thead>
                    <tr>
                      <th>{language.LC().ID}</th>
                      <th>{language.LC().EXAM_NAME}</th>
                      <th>{language.LC().PACKAGE}</th>
                      <th>{language.LC().EXPIRY_DATE}</th>
                      <th>{language.LC().STATUS}</th>
                      {/* <th className='text-center'>{language.LC().ACTION}</th> */}
                    </tr>
                  </thead>
                  {unlimitedData ? unlimitedData : null}
                  {console.log('no RESULT', this.state.no_result_display)}
                  {showPurchasedPkgDetails.length ? (
                    showPurchasedPkgDetails
                  ) : (
                    // #216 — if the hardcoded unlimited/plus row is already
                    // shown, don't also render the "no subscription" fallback.
                    unlimitedData
                      ? null
                      : renderHTMLContent(this.state.no_result_display, "td", "text-center pt-3", { colSpan: 6, contentEditable: "false" })
                  )}
                </table>
              </div>
            </div>
          )}
        </div>

        <Modal
          isOpen={this.state.isCancelSubscription}
          toggle={this.cancelSubscriptionToggle}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader>
            Cancel subscription
            <Button className='close' color='secondary' onClick={this.cancelSubscriptionToggle}>
              ×
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p className='margin_bottom_20'>
                <strong>{'Are you sure you want to cancel your subscription'}</strong>
              </p>

              <Button
                className='btn btn-sm btn-primary'
                color='primary'
                onClick={this.cancelSubscription}
              >
                {language.LC().OK}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default SubscriptionDetail;



// WEBPACK FOOTER //
// ./src/views/SubscriptionDetail/SubscriptionDetail.js